import {AxiosResponse} from "axios";
import {saveAs} from "file-saver";
import {mapMeetingNoteDetail, mapMeetingNoteSummary} from "../components/meeting-note/MeetingNoteMapper";
import {MeetingNoteDetail} from "../model/MeetingNoteDetail.model";
import {MeetingNoteSummary} from "../model/MeetingNoteSummary.model";
import {getMimeType} from "../utils/fileUtil";
import {ApiBase} from "./ApiBase";
import {IApiResult} from "./AxiosWealthManagementApi";

class MeetingNotesApiImpl {
    public requestMeetingNoteDetailForProduct(productId: number,
                                              backstopId: number): Promise<IApiResult<MeetingNoteDetail>> {
        const url = `/products/${productId}/meeting-notes/${backstopId}`;
        return ApiBase.processGet(url, (response: AxiosResponse) => {
            return mapMeetingNoteDetail(response.data);
        });
    }

    public requestLatestMeetingNoteForProduct(productId: number): Promise<MeetingNoteSummary | undefined> {
        return ApiBase.processGetUnwrapped(`/products/${productId}/meeting-note-summaries/latest`, (response: AxiosResponse) => {
            if (!response.data) return undefined;

            return mapMeetingNoteSummary(response.data);
        });
    }

    public createMeetingNoteSummaryRequest(productId: number, meetingNoteId: number, baseUrl: string) {
        return ApiBase.processPost(`/products/${productId}/meeting-notes/${meetingNoteId}/request-summary`, {baseUrl});
    }

    public requestPdf(backstopId: number, fileName: string): Promise<IApiResult<void>> {
        return ApiBase.processGet(`/meeting-notes/${backstopId}/pdf`,
            (response: AxiosResponse) => {
                const blob = new Blob([response.data], {type: getMimeType(fileName)});
                saveAs(blob, fileName);
            },
            {responseType: "arraybuffer"});
    }
}

export const MeetingNotesApi = new MeetingNotesApiImpl();
